// client/src/context/SettingsContext.jsx
// 全局品牌设置（系统标题/Logo/主题色）共享上下文
// 复用 react-query 的 'settings' key，与系统设置页保存后即时联动
import React, { createContext, useContext, useEffect } from 'react';
import { useQuery } from 'react-query';
import axios from 'axios';
import { useAuth } from './AuthContext';

const SettingsContext = createContext({ settings: null });

export const useSettings = () => useContext(SettingsContext);

const fetchSettings = async () => {
  const response = await axios.get('/api/settings');
  return response.data.settings;
};

export const SettingsProvider = ({ children }) => {
  const { isAuthenticated } = useAuth();

  const { data: settings } = useQuery('settings', fetchSettings, {
    enabled: isAuthenticated,
    retry: false,
    staleTime: 60 * 1000
  });

  // 品牌设置落地：CSS 变量 + 浏览器标题
  useEffect(() => {
    if (!settings) return;
    document.documentElement.style.setProperty('--color-primary', settings.primaryColor || '#3B82F6');
    document.documentElement.style.setProperty('--color-secondary', settings.secondaryColor || '#4F46E5');
    if (settings.systemTitle) {
      document.title = settings.systemTitle;
    }
  }, [settings]);

  return (
    <SettingsContext.Provider value={{ settings }}>
      {children}
    </SettingsContext.Provider>
  );
};
